import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { SUPPORTED_LANGUAGES } from "./MainApp/assets/utils/js/localeUtils";

import callToBookEN from "./locales/en/callToBook.json";
import commonEN from "./locales/en/common.json";
import confirmationScreenEN from "./locales/en/confirmationScreen.json";
import leavingEN from "./locales/en/leaving.json";
import stickyDrawerEN from "./locales/en/stickyDrawer.json";
import timeSelectionEN from "./locales/en/timeSelection.json";
import tourContainerEN from "./locales/en/tourContainer.json";
import tourInfoEN from "./locales/en/tourInfo.json";
import translationEN from "./locales/en/translation.json";

import callToBookES from "./locales/es/callToBook.json";
import commonES from "./locales/es/common.json";
import confirmationScreenES from "./locales/es/confirmationScreen.json";
import leavingES from "./locales/es/leaving.json";
import stickyDrawerES from "./locales/es/stickyDrawer.json";
import timeSelectionES from "./locales/es/timeSelection.json";
import tourContainerES from "./locales/es/tourContainer.json";
import tourInfoES from "./locales/es/tourInfo.json";
import translationES from "./locales/es/translation.json";

import callToBookFR from "./locales/fr/callToBook.json";
import commonFR from "./locales/fr/common.json";
import confirmationScreenFR from "./locales/fr/confirmationScreen.json";
import leavingFR from "./locales/fr/leaving.json";
import stickyDrawerFR from "./locales/fr/stickyDrawer.json";
import timeSelectionFR from "./locales/fr/timeSelection.json";
import tourContainerFR from "./locales/fr/tourContainer.json";
import tourInfoFR from "./locales/fr/tourInfo.json";
import translationFR from "./locales/fr/translation.json";

import callToBookIT from "./locales/it/callToBook.json";
import commonIT from "./locales/it/common.json";
import confirmationScreenIT from "./locales/it/confirmationScreen.json";
import leavingIT from "./locales/it/leaving.json";
import stickyDrawerIT from "./locales/it/stickyDrawer.json";
import timeSelectionIT from "./locales/it/timeSelection.json";
import tourContainerIT from "./locales/it/tourContainer.json";
import tourInfoIT from "./locales/it/tourInfo.json";
import translationIT from "./locales/it/translation.json";

import callToBookZH from "./locales/zh/callToBook.json";
import commonZH from "./locales/zh/common.json";
import confirmationScreenZH from "./locales/zh/confirmationScreen.json";
import leavingZH from "./locales/zh/leaving.json";
import stickyDrawerZH from "./locales/zh/stickyDrawer.json";
import timeSelectionZH from "./locales/zh/timeSelection.json";
import tourContainerZH from "./locales/zh/tourContainer.json";
import tourInfoZH from "./locales/zh/tourInfo.json";
import translationZH from "./locales/zh/translation.json";

const resources = {
  en: {
    callToBook: callToBookEN,
    common: commonEN,
    confirmationScreen: confirmationScreenEN,
    leaving: leavingEN,
    stickyDrawer: stickyDrawerEN,
    timeSelection: timeSelectionEN,
    tourContainer: tourContainerEN,
    tourInfo: tourInfoEN,
    translation: translationEN,
  },
  es: {
    callToBook: callToBookES,
    common: commonES,
    confirmationScreen: confirmationScreenES,
    leaving: leavingES,
    stickyDrawer: stickyDrawerES,
    timeSelection: timeSelectionES,
    tourContainer: tourContainerES,
    tourInfo: tourInfoES,
    translation: translationES,
  },
  fr: {
    callToBook: callToBookFR,
    common: commonFR,
    confirmationScreen: confirmationScreenFR,
    leaving: leavingFR,
    stickyDrawer: stickyDrawerFR,
    timeSelection: timeSelectionFR,
    tourContainer: tourContainerFR,
    tourInfo: tourInfoFR,
    translation: translationFR,
  },
  it: {
    callToBook: callToBookIT,
    common: commonIT,
    confirmationScreen: confirmationScreenIT,
    leaving: leavingIT,
    stickyDrawer: stickyDrawerIT,
    timeSelection: timeSelectionIT,
    tourContainer: tourContainerIT,
    tourInfo: tourInfoIT,
    translation: translationIT,
  },
  zh: {
    callToBook: callToBookZH,
    common: commonZH,
    confirmationScreen: confirmationScreenZH,
    leaving: leavingZH,
    stickyDrawer: stickyDrawerZH,
    timeSelection: timeSelectionZH,
    tourContainer: tourContainerZH,
    tourInfo: tourInfoZH,
    translation: translationZH,
  },
};

i18next.use(LanguageDetector).use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  supportedLngs: SUPPORTED_LANGUAGES,
  load: "languageOnly",
  ns: Object.keys(resources.en),
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ["querystring", "localStorage", "navigator"],
    lookupQuerystring: "lang",
    caches: ["localStorage"],
  },
});

export default i18next;
